export const ExperimentNames = {
    // Forever experiment
    UseWarmupState: 'specs.events.ui.UseWarmupState',
    EventDetailsSlots: 'specs.events.ui.EventDetailsSlots',
    EventDetailsSlotsViewer: 'specs.events.ui.EventDetailsSlotsViewer',
    DashboardSlots: 'specs.events.ui.DashboardSlots',
    ExpressCheckout: 'specs.events.ui.ExpressCheckout',
    RsvpDynamicMessages: 'specs.events.ui.RsvpDynamicMessages',
    RicosBusinessManager: 'specs.events.ui.Ricos',
    RicosViewer: 'specs.events.ui.RicosViewer',
    SausageIntegration: 'specs.events.ui.SausageIntegration',
    RemoveLiveVideoAccess: 'specs.events.ui.RemoveLiveVideoAccess',
    UpdatedClassicAddPanel: 'specs.events.ui.UpdatedClassicAddPanel',
    UpdatePaymentTermsPaypal: 'specs.events.ui.UpdatePaymentTermsPaypal',
    UpdatePaymentTermsSquare: 'specs.events.ui.UpdatePaymentTermsSquare',
    SettingsPanelUpdatedTranslations: 'specs.events.ui.SettingsPanelUpdatedTranslations', // false 100%, 2024,07-12
    EventsListRedesign: 'specs.events.ui.EventsListRedesign', // English 100%, 2024-07-12
    DisableEventCreationForPaypal: 'specs.events.ui.DisableEventCreationForPaypal',
    DescriptionVisibility: 'specs.events.ui.DescriptionVisibility', // false 100%, 2024-07-12
    AddMultipleGuestsManually: 'specs.events.ui.AddMultipleGuestsManually',
    SingleEventNoRegistrationTextSetting: 'specs.events.ui.SingleEventNoRegistrationTextSetting', // English 100%, 2024-07-12
    BMContentUpdates: 'specs.events.ui.BMContentUpdates', // English 100%, 2024-07-12
    EventsApps: 'specs.events.ui.EventsApps',
    TicketMoreInfoButtonSetting: 'specs.events.ui.TicketMoreInfoButtonSetting',
    AiAssistant: 'specs.events.ui.AiAssistant',
    NewPolicyFontColor: 'specs.events.ui.NewPolicyFontColor',
    ServiceFeeEnforcementUpdates: 'specs.events.ui.ServiceFeeEnforcementUpdates',
    UpdatedCheckoutSummary: 'specs.events.ui.UpdatedCheckoutSummary',
    CategoriesUXImprovements: 'specs.events.ui.CategoriesUXImprovements',
    GuestListDefaultSort: 'specs.events.ui.GuestListDefaultSort',
    UpdatePaymentMethodEnabled: 'specs.events.ui.UpdatePaymentMethodEnabled',
    AutomationV3Enabled: 'automations.SiteOnV3AutomationsBuilder',
    OfferExpressCheckout: 'specs.events.ui.OfferExpressCheckout',
    WidgetSEOTags: 'specs.events.ui.WidgetSEOTags',
    AddMultipleGuestsManuallyRSVP: 'specs.events.ui.AddMultipleGuestsManuallyRSVP',
};
//# sourceMappingURL=experiments.js.map